import config from '../vuestrap/config'
import autoload from './autoload'

export {config, autoload}
const adminstrap = {config, autoload}
export default adminstrap

